// Wait for the DOM to be ready.
document.addEventListener('DOMContentLoaded', e => {
   const openButton = document.querySelector("modal-open");
   const closeButton = document.querySelector("#modal-close");
   const dialog = document.querySelector("#modal");
   const body = document.body;
})

let clickTracking = (label) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
      "event": "interaction",
      "type": "Modal Pop Up",
      "interaction": {
          "name": "Get An Estimate - Select Lawn Range",
          "action": "interacted",
          "value": label
      }
  })
}

function openLawnSizeModal() {
  const dialog = document.querySelector("#modal");
   dialog.showModal();
   document.body.classList.add('fixed');
   dialog.addEventListener("click", e => {
    const dialogDimensions = dialog.getBoundingClientRect()
    if (
      e.clientX < dialogDimensions.left ||
      e.clientX > dialogDimensions.right ||
      e.clientY < dialogDimensions.top ||
      e.clientY > dialogDimensions.bottom
    ) {
      document.body.classList.remove('fixed');
      dialog.close()
    }
   if(e.target.classList.contains('label__modal')) {
     clickTracking(e.target.title)
    }
  })
}

function closeLawnSizeModal() {
  const dialog = document.querySelector("#modal");
   document.body.classList.remove('fixed');
   dialog.close();
}

function activateTab(e) {
  document.getElementById(e.target.htmlFor).checked = true;
}

// Adding tracking click events for tabs
// let elements = document.querySelectorAll('.label__modal');

// console.log(elements)

// let clickTracking = () => {
//     console.log('Something')
// }

// elements.forEach((item) => {
//     item.addEventListener('click', clickEvent)
// });

// let element = document.getElementById('modal');

// element.addEventListener('click', (e) => {
//   if(e.target.classList.contains('label__modal')) {
//     console.log('some event content here...');
//   }
// });
